import { formatMessage } from '@99designs/common/i18n/index';
import { trackEvent } from '@99designs/common/utils/platform';
import Button from 'common/components/Button';
import Link from 'launch/components/Link';
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { ColorMapColor } from './ColorMap';
import { ColorResult } from './ColorSliderApp';

interface Prop {
    resultColor: ColorResult;
}

export default class ColorSliderAppResult extends React.Component<Prop> {
    render() {
        const { color } = this.props.resultColor;

        trackEvent('Clicked coloromatic CTA', {
            color: color,
            sliderInput: this.state,
        });

        return (
            <div>
                {this.renderColorResultContent()}
                {this.renderHelpContent()}
            </div>
        );
    }

    renderPantoneInfo() {
        if (this.props.resultColor.pantone) {
            const { name, colorId } = this.props.resultColor.pantone;
            return (
                <div className="pantone">
                    <div
                        className="pantone__color-box"
                        style={{ backgroundColor: this.props.resultColor.hex }}
                    />
                    <div className="pantone__meta">
                        <img src={require(`images/psych-of-color/pantone-logo.png`)} />
                        <div className="paragraph paragraph--no-margin">{colorId}</div>
                        <div className="paragraph paragraph--no-margin">{name}</div>
                        <div className="paragraph paragraph--no-margin">
                            HEX {this.props.resultColor.hex.replace('#', '')}
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderColorResultContent() {
        const { color, hex, designer } = this.props.resultColor;

        const headingStyles = {
            color: hex,
            textShadow:
                color === ColorMapColor.White ? '0 6px 20px rgba(28, 27, 26, 0.3)' : undefined,
        };

        return (
            <div className="section section--collapse-bottom">
                <div className="row">
                    <div className="column large-6 normal-6 medium-12 small-12">
                        <figure className="design-figure design-figure--attribution-bottom-left">
                            <div className="design-figure__image-container">
                                <img src={require(`images/psych-of-color/${color}.png`)} />
                            </div>
                            <figcaption className="design-figure__attribution">
                                <span className="attribution attribution--small ">
                                    {formatMessage(__('by {designer}'), { designer: designer })}
                                </span>
                            </figcaption>
                        </figure>
                    </div>
                    <div className="column large-6 normal-6 medium-12 small-12">
                        <div className="heading heading--h3 heading--h3-capped heading--no-margin">
                            <FormattedHTMLMessage id="psych_of_colors.results.title" />
                        </div>
                        <div
                            className={`heading heading--chameleon heading--psych-of-color heading--no-margin`}
                            style={headingStyles}
                        >
                            <FormattedMessage id={`psych_of_colors.${color}.title`} />
                        </div>

                        {this.renderPantoneInfo()}

                        <div className="paragraph">
                            <FormattedHTMLMessage id={`psych_of_colors.${color}.description`} />
                        </div>
                        <div className="paragraph" style={{ color: hex }}>
                            <Button
                                size="jumbo"
                                color={color !== ColorMapColor.White ? 'chameleon' : 'black-border'}
                                variation="primary"
                                responsive={true}
                                href={`/designers/search?q=${color}`}
                                target="_blank"
                                onClick={() => trackEvent('Clicked coloromatic see more CTA')}
                            >
                                <FormattedHTMLMessage id={`psych_of_colors.${color}.button`} />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHelpContent() {
        return (
            <div className="section section--collapse-top">
                <div className="row">
                    <div className="column">
                        <div className="long-form-free-content">
                            <div className="paragraph">
                                <FormattedHTMLMessage id="psych_of_colors.results.paragraph_1" />
                            </div>
                            <div className="paragraph">
                                <FormattedHTMLMessage id="psych_of_colors.results.paragraph_2" />
                            </div>
                            <div className="paragraph">
                                <FormattedMessage
                                    id="psych_of_colors.results.paragraph_3"
                                    values={{
                                        colorWheel: (
                                            <Link
                                                href="https://color.adobe.com/create/color-wheel"
                                                target="_blank"
                                                variations={['default']}
                                            >
                                                <FormattedMessage
                                                    id={'psych_of_colors.results.colorWheel'}
                                                />
                                            </Link>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
